import request from '../utils/Request';
import { Methods } from '../config';

export const exportInvoiceXml = (data) => request({
  resource: 'invoice-xml/export',
  method: Methods.POST,
  responseType: 'blob',
  data,
});
